import React from 'react';
import { useParams } from 'react-router-dom';
import AdminEntityList from './AdminEntityList';
import { ENTITY_COLUMNS, ENTITY_TITLES } from './columns';

// Single dynamic route (/admin/emerge/:entity) backing every eMerge nav
// item in AdminLayout — the per-entity config lives in columns.ts instead
// of one route + one component per table.
export default function EmergeEntityPage() {
  const { entity } = useParams<{ entity: string }>();
  const columns = entity ? ENTITY_COLUMNS[entity] : undefined;

  if (!entity || !columns) {
    return (
      <div className="p-6">
        <h1 className="text-xl font-semibold text-foreground">Unknown record type</h1>
        <p className="mt-1 text-sm text-muted-foreground">Unknown eMerge entity.</p>
      </div>
    );
  }

  return <AdminEntityList entity={entity} title={ENTITY_TITLES[entity] || entity} columns={columns} />;
}
